export enum SKELETON_CHECKOUT_CONST {
  TEST_ID = 'skeleton-checkout',
}
